import { ApolloError, ServerError } from '@apollo/client'

interface GraphQLErrorResult {
  errors: Array<{
    extensions: {
      code: GraphQLErrorCode
    }
  }>
}

export type GraphQLErrorCode = 'USER_MUST_NOT_BE_DELETED'
  | 'USER_MUST_BE_CONFIRMED'
  | 'INVALID_USER_CREDENTIALS'
  | 'SSO_REQUIRED'
  | 'USER_IP_NOT_ALLOWED'
  | 'USER_LOCKED'
  | 'TOO_MANY_REQUESTS'

export const getGraphQLErrorCode = (error: ApolloError): GraphQLErrorCode | null => {
  const networkError = error.networkError as ServerError
  const result = networkError?.result as GraphQLErrorResult

  const code = result?.errors?.[0]?.extensions?.code
  return code || null
}

export const ERROR_MESSAGES: Record<GraphQLErrorCode, string> = {
  USER_MUST_NOT_BE_DELETED: 'auth.account_status.disabled_contact_support',
  USER_MUST_BE_CONFIRMED: 'auth.account_status.unconfirmed',
  INVALID_USER_CREDENTIALS: 'auth.account_status.invalid_credentials',
  SSO_REQUIRED: 'login.error.sso_required',
  USER_IP_NOT_ALLOWED: 'login.error.ip_not_allowed',
  USER_LOCKED: 'login.error.password_locked',
  TOO_MANY_REQUESTS: 'login.error.too_many_requests'
}
